/* eslint-disable sciencepo-rules/require-story */
/* Ce test avec Faculty diapo */

import * as facultyDiapoStyles from '../../styles/internal-page/faculty-diapo.module.scss';
import PropTypes from 'prop-types';
import React from 'react';
import PolyLink from '../shared/PolyLink';

const FacultyContent = ({elem}) => {
  return (
    <>
      <p className={facultyDiapoStyles.title}>
        {elem.first_name + ' ' + elem.last_name}
      </p>
      <p className={facultyDiapoStyles.job}>
        {elem.job}
      </p>
      <p className={facultyDiapoStyles.job}>
        {elem.jobDescription}
      </p>
      <div className={facultyDiapoStyles.separator}/>
      <div className={facultyDiapoStyles.biography}>
        {elem.biography}
      </div>
      {elem.link && elem.link_label &&
        <PolyLink
          ariaLabel={elem.link_label}
          className={facultyDiapoStyles.button}
          url={elem.link}
        >
          {elem.link_label}
        </PolyLink>
      }
    </>
  );
};

FacultyContent.propTypes = {
  elem: PropTypes.shape({
    first_name: PropTypes.string.isRequired,
    link_label: PropTypes.string,
    link: PropTypes.string,
    jobDescription: PropTypes.string,
    last_name: PropTypes.string.isRequired,
    job: PropTypes.string,
    biography: PropTypes.string,
  }).isRequired,
};

export default FacultyContent;
